import { render, staticRenderFns } from "./TermometriaCadastro.vue?vue&type=template&id=21247978&"
import script from "./TermometriaCadastro.vue?vue&type=script&lang=js&"
export * from "./TermometriaCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports